import classNames from 'classnames';
import { FC, HTMLAttributes, ReactNode, useEffect } from 'react';
import { CaseList } from '../../services/apiService';
import Icon from '../icon/Icon';
import Button from '../ui/Button';
import Card, { CardBody, CardFooter, CardHeader } from '../ui/Card';
import Tooltip from '../ui/Tooltip';
import Input from './Input';
interface ILabelProps extends HTMLAttributes<HTMLLabelElement> {
	children: ReactNode;
	description?: string;
	className?: string;
	htmlFor: string;
}
const Label: FC<ILabelProps> = (props) => {
	const { children, className, description, ...rest } = props;
	return (
		<label
			data-component-name='Label'
			className={classNames('mb-2 inline-block w-full cursor-pointer text-sm', className)}
			{...rest}>
			{children}
			{description && <Tooltip className='ms-2 align-baseline' text={description} />}
		</label>
	);
};
export default Label;
interface IPatientProps {
	firstName?: string;
	lastName?: string;
	email?: string;
	className?: string | null;
	MoblieNo?: string;
	id?: string ;
}
export const PatientCard: FC<IPatientProps> = (props) => {
	
    const {response , loading, call} =CaseList();
	const { firstName, lastName, email, MoblieNo, className,id } = props;
    useEffect(() => {
		call(id!).subscribe({
			error: (e) => { console.log(e) }
		});
    }, [id]);
	return (
		<>
			<div className={classNames("mt-3 bg-white flex flex-col p-4 gap-4 capitalize w-full", className)} >
				<div className='font-semibold  '>	patient Information:</div>
				<div className='flex justify-between  w-full px-10'>
					<div className='flex'>
						name  : {firstName! + lastName!} </div>
					<div className='flex'>
						Email : {email} </div>
					<div className='flex'>
						Moblie No  : {MoblieNo} </div>
				</div>
				<div className='font-semibold flex gap-2 items-center'>
					<span>cases:  </span> <Button size='default' variant='solid' >New Cases</Button>
				
				</div>
				
				{/* <div className='w-full flex gap-8 px-10 overflow-x-auto'>
					{response?patientid?.length && response?patientid?.length.map((item: any, index: any) => (<Card className='p-2 w-52  shadow-md m-2' key={index}>
						<CardHeader className='font-semibold'> {item.caseName}</CardHeader>
						<CardBody className='text-zinc-500'>
							{item.createdAt}</CardBody></Card>))}
				</div> */}
			
			</div>
			<PatientviewCase />
		</>
	);
};
export const PatientviewCase: FC<IPatientProps> = () => {
	return (
		<>
			<div className={classNames("mt-3 bg-white flex flex-col p-4 gap-4 capitalize ")} >
				<div className='flex items-center gap-5' >
					<span className='font-bold '>case Information : </span>
					<div className='w-52'>
						<Input type="text" dimension='lg' name="case id " id="case id" value="2" />
					</div>
					<Button size='default' variant='solid' >update</Button>
				</div>
			</div>
			<SoapNotes />
		</>
	);
};
export const SoapNotes: FC<IPatientProps> = () => {
	return (<>
		<div className='grid  grid-cols-2 gap-3 p-3'>
			<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>	<Icon
						data-component-name='delete-icon'
						icon={"DuoDeletedFile"}
						className={classNames(
							'w-12 flex-none text-3xl text-red-800 ',
						)}
					/></CardFooter></div>
			</Card>	<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>
						<Icon
							data-component-name='delete-icon'
							icon={"DuoDeletedFile"}
							className={classNames(
								'w-12 flex-none text-3xl text-red-800 ',
							)}
						/></CardFooter>
						</div>
			</Card>
	<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>
						<Icon
							data-component-name='delete-icon'
							icon={"DuoDeletedFile"}
							className={classNames(
								'w-12 flex-none text-3xl text-red-800 ',
							)}
						/></CardFooter>
						</div>
			</Card>
			
<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>
						<Icon
							data-component-name='delete-icon'
							icon={"DuoDeletedFile"}
							className={classNames(
								'w-12 flex-none text-3xl text-red-800 ',
							)}
						/></CardFooter>
						</div>
			</Card>
			
	<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>
						<Icon
							data-component-name='delete-icon'
							icon={"DuoDeletedFile"}
							className={classNames(
								'w-12 flex-none text-3xl text-red-800 ',
							)}
						/></CardFooter>
						</div>
			</Card>
			<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>
						<Icon
							data-component-name='delete-icon'
							icon={"DuoDeletedFile"}
							className={classNames(
								'w-12 flex-none text-3xl text-red-800 ',
							)}
						/></CardFooter>
						</div>
			</Card>
			<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>
						<Icon
							data-component-name='delete-icon'
							icon={"DuoDeletedFile"}
							className={classNames(
								'w-12 flex-none text-3xl text-red-800 ',
							)}
						/></CardFooter>
						</div>
			</Card>
			<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>
						<Icon
							data-component-name='delete-icon'
							icon={"DuoDeletedFile"}
							className={classNames(
								'w-12 flex-none text-3xl text-red-800 ',
							)}
						/></CardFooter>
						</div>
			</Card>
			<Card className='p-2   shadow-md m-2' >
				<CardHeader className='font-semibold'>Initial note:8326efea-6319-4212-bdal-0929095bd170</CardHeader>
				<div className='flex justify-between'>
					<CardBody className='text-zinc-500'>
						3rd Dec 2024 - 12:24:22 pm	</CardBody>
					<CardFooter>
						<Icon
							data-component-name='delete-icon'
							icon={"DuoDeletedFile"}
							className={classNames(
								'w-12 flex-none text-3xl text-red-800 ',
							)}
						/></CardFooter>
						</div>
			</Card>
			
		</div>
	</>
	);
};